import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useMemo } from "react";
import { Button, Form } from "react-bootstrap";
import moment from "moment";
import { useFormik } from "formik";
import { DateRangePicker } from "rsuite";
import { BiDownload, BiSearch } from "react-icons/bi";
import { Stack } from 'rsuite';
import startOfMonth from 'date-fns/startOfMonth';
import Sidebar from "../../includes/Sidebar";
import { downloadXl, predefinedBottomRanges } from "../../../functions";
import { Tooltip } from "@mui/material";
import { seErrorMessage } from "../../../slice/error/errorSlice";
import { useDispatch } from "react-redux";
import Select, { components } from "react-select";
import { InvoiceReportService } from "../../../services/InvoiceReportService";
import { getUnmatchedKeys } from "../../../utils/objectUtils";
import { ReportService } from "../../../services/ReportService";
import { format } from "date-fns";
import { DataListService } from "../../../services/DataListService";
import { HiChevronDown } from "react-icons/hi";
import { TbGridDots } from "react-icons/tb";


const datatableCustomStyles = {
  rows: {
    style: {
      minHeight: '20px', // override the row height
      fontSize: '0.7em',
      fontColor: '#212529 !important',
      width: '100%'
    },
  },
  headCells: {
    style: {
      paddingLeft: '5px', // override the cell padding for head cells
      paddingRight: '5px',
      textTransform: "uppercase",
      fontSize: '0.7em',
      fontWeight: '800',
      fontColor: '#6c757d !important',
      opacity: 1,
      minHeight: "10px",
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
      width: "100%",
    },
  },
  pagination: {
    style: {
      color: '#000',
      fontSize: '13px',
      minHeight: '56px',
      backgroundColor: '#fff',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: '#f2f2f2',
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      padding: '8px',
      margin: '0px',
      cursor: 'pointer',
      transition: '0.4s',
      color: '#000',
      fill: '#000',
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: '#e2e2e2',
        fill: '#e2e2e2',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#f2f2f2',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#f5f5f5',
      },
    },
  },
};

function Monthlysummaryreport() {
  const dispatch = useDispatch()

  const [reRenderDataTable, setRerenderDataTable] = useState(false)
  const [pageno, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isTimeCount, setisTimeCount] = useState(false);
  const [totalRows, setTotalRows] = useState(100);
  const [colorRow, setColorRow] = React.useState({});
  const [data, setData] = useState({})
  const [limit, setLimit] = useState(100)
  const [searchedData, setSearchedData] = useState({
    status: "",
    date_range: `${moment(startOfMonth(new Date().setHours(0, 0, 0, 0))).format('MM/DD/YYYY HH:mm:ss')} - ${moment(new Date().setHours(23, 59, 59, 59)).format('MM/DD/YYYY HH:mm:ss')}`,
    group_id: ""
  })
  const [isFocusedGroup, setIsFocusedGroup] = useState(false);

  const [isInitSearch, setIsInitSearch] = useState(true)
  const [clientgroup, setClientgroup] = useState()

  const reportSevice = new ReportService()
  const dataListService = new DataListService();
  const { getAutoreRorter } = reportSevice
  const { getClientGrouplist } = dataListService;

  const DropdownIndicator = ({ state, ...props }) => {
    return (
      <components.DropdownIndicator {...props}>
        {filterState && filterState[state] && filterState[state].length > 1 ? <TbGridDots style={{ fontSize: "1.5em" }} /> : <HiChevronDown style={{ fontSize: "1.5em" }} />}
      </components.DropdownIndicator>
    );
  };
  const [filterState, setFilterState] = useState([
    {
      status: "",
      group_id: "",

    },
  ]);
  const handleOnMultySelectChange = async (selected, name) => {
    let selectedIds = [];

    selected.map((option) => {
      selectedIds.push(option.value);
    });

    searchFormik.setValues({ ...searchFormik.values, [name]: selectedIds });
    setFilterState({
      ...filterState,
      [name]: selected,
    });
  };

  const handlePerRowsChange = async (newPerPage, page) => {

    setLimit(newPerPage);
    setPageNo(1)
    fetchData(1, newPerPage, searchedData?.date_range, searchedData?.status, searchedData?.group_id);
    handleResetDataTable()

  };

  const handlePageChange = page => {
    setPageNo(page)
    fetchData(page, limit, searchedData?.date_range, searchedData?.status, searchedData?.group_id);
  };


  function formatDateRange(dateRange) {
    if (!Array.isArray(dateRange) || dateRange.length !== 2) {
      return '';
    }

    const [start, end] = dateRange.map((d) => new Date(d)); // Convert timestamps to Date objects

    const formattedStart = format(start, 'MM/dd/yyyy') + ' 00:00:00';
    const formattedEnd = format(end, 'MM/dd/yyyy') + ' 23:59:59';

    return `${formattedStart} - ${formattedEnd}`;
  }

  const fetchData = (page, limit, full_date_range, status, group_id) => {
    setLoading(true)


    const date_range = formatDateRange(full_date_range)
    const report_type = [14]

    getAutoreRorter(page, limit, date_range, status, report_type, group_id).then((response) => {
      setData(response?.data);
      setLimit(limit);
      setPageNo(page)
      setTotalRows(response?.data?.count);
      setLoading(false);
      if (response?.errors?.date_range) {
        dispatch(seErrorMessage({ message: response?.errors?.date_range[0], is_show: true }))
      }
    });

  }
  useEffect(() => {
    getClientGrouplist().then((response) => {
      setClientgroup(response?.data)
    })
  }, [])


  const searchFormik = useFormik({

    initialValues: {

      date_range: [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date().setHours(23, 59, 59, 59)],
      status: [],
      group_id: []

    }, validate: (value) => {
      console.log(value, "values");
      const errors = {};
      if (!value?.date_range?.length > 0 && !value?.created_date.length > 0) {
        errors.date_range = "Required";
        errors.created_date = "Required";
      }
      return errors;
    },
    onSubmit: (values) => {

      setIsInitSearch(false)
      searchData(values)
      setSearchedData({
      })
      handleResetDataTable()
    }
  })



 
  const handleRowClick = (row) => {
                 setColorRow(row);
                 // // console.log(row);
         };
 
   const columns = useMemo(
       () => [
         {
           id: 'S.NO',
           name: 'S.NO',
           selector: (row, index) =>
             Number(pageno) > 1
               ? (Number(pageno) - 1) * Number(limit) + index + 1
               : index + 1,
               cell:(row,index)=>
                <div style={{width:"100%"}} onClick={() => handleRowClick(row)}>
   {Number(pageno) > 1
               ? (Number(pageno) - 1) * Number(limit) + index + 1
               : index + 1}
  
                </div>,
  
                
           wrap: true,
           width: "10%",
           grow: 0.1,
   
         },
         {
           id: ' NAME',
           name: ' cLIENT GROUP NAME',
           width: "30%",
           selector: row => "User report",
           cell: (row) =>
   
             <span style={{width:"100%"}} onClick={() => handleRowClick(row)} className="text-truncate"> {row?.group_name}</span>
   
           ,
   
   
           left: true,
           wrap: true,
           reorder: false,
           grow: 0.1,
           expandOnRowClicked: true,
   
         },
         {
           id: " DATE RANGE",
           name: "DATE RANGE",
           width: "30%",
           sort_key: "data_range",
           selector: (row) => moment(row?.ist_date_range).format("MM/DD/YY"),
           cell: (row) => <span style={{width:"100%"}} onClick={() => handleRowClick(row)} > {row?.ist_date_range}</span>,
           sortable: true,
           reorder: true,
           left: true,
           wrap: true,
           grow: 0.2,
   
         },
         {
           id: 'STATUS',
           name: 'STATUS',
           width: "10%",
           selector: row => row?.status,
           cell: (row) =>
   
             <span style={{width:"100%"}} onClick={() => handleRowClick(row)} className="text-truncate"> {row?.status}</span>
   
           ,
   
   
           left: true,
           wrap: true,
           reorder: false,
           grow: 0.1,
           expandOnRowClicked: true,
   
         },
   
         {
           id: "action",
           name: "Action",
           width: "20%",
           reorder: true,
           // omit: !state.status,
           cell: (row) => (
             <React.Fragment>
               {/* {row?.job_status == 'Snipping Completed' && row?.snippet_image && row?.snippet_image != '' && */}
               <div style={{width:"100%"}}
               onClick={() => handleRowClick(row)} 
                 className="me-2 d-flex justify-content-center align-items-center gap-2 job-monitor-table-wrapper"
               >
                 <React.Fragment>
                   <Tooltip disableInteractive title="Download" placement="top" arrow>
                     <div
                       className={""}
                       style={{ fontSize: "1.5em" }}
                       onClick={() => {
                         downloadXl(row?.export_file);
                       }}
                     >
                       <BiDownload color={"#000000"} />
                     </div>
                   </Tooltip>
                 </React.Fragment>
               </div>
   
               {/* } */}
             </React.Fragment>
           ),
           // ignoreRowClick: true,
           // allowOverflow: false,
           // button: true,
           center: true,
   
         },
   
       ],
   
       [limit, pageno, isTimeCount],
     );
   
  


  const conditionalRowStyles = [

    {
      when: row => colorRow.id == row.id ? true : false,
      style: (row, index) => ({
        backgroundColor: colorRow?.id == row.id ? '#dbf4f5' : '#f2f2f2',
        color: 'black',
        // fontWeight: '550'
      }),
    },


  ];


  const handleOnDateTimeChange = ({ name, value }) => {
    searchFormik.setValues({ ...searchFormik.values, [name]: value ?? "" });
  }



  const searchData = ({ date_range, status, group_id }) => {
    fetchData(1, limit, date_range, status, group_id)
  }

  const handleResetDataTable = () => {
    setRerenderDataTable(true)

  }

  const [statuses, _] = useState([
    { value: "PENDING", label: "Pending" },
    { value: "IN_PROCESS", label: "In Process" },
    { value: "FAILED", label: "Failed" },
    { value: "COMPLETED", label: "Completed" },
  ]);

  return (
    <React.Fragment>
      {/* <Header /> */}
      <Sidebar />
      <main id="main" className="main">

        <div className="pagetitle tab-fixed-header">
          <h1 id='page-title'>Monthly Summary Report</h1>
        </div>

        <section className="section mt-5 ">
          <div className="row align-items-top py-2 gap-2 gap-md-5">
            <div className="col-lg-12">
              <div className="card mb-5 mb-xl-8 mt-3">

                <Form onSubmit={searchFormik.handleSubmit} >
                  <div className=" ">
                    <div className="px-1 py-1 d-flex pe-2 flex-row  gap-2 align-items-center flex-wrap">

                      <Tooltip disableInteractive title={"Processed Date"} placement="top" arrow>

                        <div className={`${searchFormik.errors.date_range ? "date-range-pickr-error " : ""}  correspondenceDatePicker"`}>
                          <Stack direction="column" spacing={8} alignItems="flex-start">

                            <DateRangePicker
                              // style={{ backgroundColor: "#000" }}
                              ranges={predefinedBottomRanges}
                              cleanable={false}
                              placement="auto"
                              appearance="default" format={"MM/dd/yyyy HH:mm:ss"}
                              className="form-date-control form-control-solid b-r-1 text-dark"
                              placeholder={"MM/DD/YYYY HH:mm:ss - MM/DD/YYYY HH:mm:ss"}
                              name="date_range"
                              onChange={(e) => { handleOnDateTimeChange({ name: 'date_range', value: e }) }}
                              value={searchFormik?.values?.date_range} />
                          </Stack>
                        </div>
                      </Tooltip>
                      <div className="-tat">

                        <Select
                          isMulti
                          options={statuses}
                          className="select-search"
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="status" /> }}
                          classNamePrefix="select"
                          placeholder=" Status"
                          isClearable
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          name="status"
                          onFocus={() => setIsFocusedGroup(true)}
                          onBlur={() => setIsFocusedGroup(false)}
                          onChange={(e) => handleOnMultySelectChange(e, "status")}
                          defaultValue={searchFormik?.values?.status}
                          value={statuses?.filter(option =>
                            searchFormik?.values?.status?.some(selected => selected === option.value)
                          )}
                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none",
                              boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: (styles) => ({
                              ...styles,
                              width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),

                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: "scroll",
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? "#d9f4f5" : "inherit",
                              color: state.isSelected ? "#000000" : "inherit",
                              "&:hover": { backgroundColor: state.isSelected ? "#d9f4f5" : "rgb(222, 235, 255)" },
                            }),
                          }}
                        />
                      </div>
                      <div className="-tat">
                        <Select
                          isMulti
                          options={clientgroup}
                          className="select-search"
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="group_id" /> }}
                          classNamePrefix="select"
                          placeholder=" Client Group"
                          isClearable
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          name="group_id"
                          onFocus={() => setIsFocusedGroup(true)}
                          onBlur={() => setIsFocusedGroup(false)}
                          onChange={(e) => handleOnMultySelectChange(e, "group_id")}
                          defaultValue={searchFormik?.values?.group_id}
                          value={clientgroup?.filter(option =>
                            searchFormik?.values?.group_id?.some(selected => selected === option.value)
                          )}
                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none",
                              boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: (styles) => ({
                              ...styles,
                              width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),

                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: "scroll",
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? "#d9f4f5" : "inherit",
                              color: state.isSelected ? "#000000" : "inherit",
                              "&:hover": { backgroundColor: state.isSelected ? "#d9f4f5" : "rgb(222, 235, 255)" },
                            }),
                          }}
                        />

                      </div>
                      <div>
                        <Tooltip disableInteractive title={"Search"} placement="top" arrow>
                          <Button className="btn btn-light btn-active-primary" type="submit">
                            <span className="svg-icon svg-icon-3">
                              <BiSearch />
                            </span>

                          </Button>
                        </Tooltip>
                      </div>



                    </div>
                  </div>

                </Form>


                <div className="card-body p-common">
                  <div className="table-responsive">
                    <div className="dashboardtable">
                      {/* {!reRenderDataTable && */}
                      <DataTable
                        className="custom-datatable"
                        paginationDefaultPage={pageno}

                        fixedHeader={true}
                        progressPending={loading}
                        data={data?.results}
                        columns={columns}
                        pointerOnHover={true}
                        pagination
                        paginationServer
                        // highlightOnHover
                        paginationTotalRows={totalRows}
                        paginationPerPage={limit}
                        paginationRowsPerPageOptions={[25, 50, 100, 150, 200]}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        conditionalRowStyles={conditionalRowStyles}
                        theme="solarized"
                        customStyles={datatableCustomStyles}
                        striped={true}

                        expandableRows
                        expandOnRowClicked={false}
                        expandableRowsHideExpander
                        noDataComponent={isInitSearch ? <p className="p-4">Apply filters to refine and display the data</p> : <p className="p-4">There are no records to display</p>}


                      />
                      {/* } */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>



      </main>
    </React.Fragment >
  )
}
export default Monthlysummaryreport




